import { useEffect } from 'react';
import Aos from 'aos';

import NavBar from './component/NavBar';
import Header from './component/Header';
import Main from './component/Main';
import Footer from './component/Footer';

import "aos/dist/aos.css";
import './App.css';

function App() {
  useEffect(() => {
    Aos.init({ delay: 500, once: true, mirror: false });
  }, [])
  return (
    <div className="App">
      <header className="App-header">
        <NavBar />
        <Header />
        <Main />
        <Footer />
      </header>
    </div>
  );
}

export default App;
